import { createAction } from 'redux-actions'

export const SET_CLASIFICATIONS = createAction('SET_CLASIFICATIONS')
